import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export default function MayoristaModal({ show, handleClose }) {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '',
    whatsapp: false
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!formData.nombre.trim()) newErrors.nombre = 'El nombre es obligatorio.';
    if (!formData.email.trim()) newErrors.email = 'El email es obligatorio.';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'El email no es válido.';

    if (!formData.mensaje.trim()) newErrors.mensaje = 'El mensaje es obligatorio.';
    if (formData.telefono && !/^[0-9+\-()\s]{6,20}$/.test(formData.telefono)) {
      newErrors.telefono = 'El teléfono no es válido.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = e => {
  const { name, value, type, checked } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: type === 'checkbox' ? checked : value
  }));
};

  const handleSubmit = e => {
    e.preventDefault();
    if (!validate()) return;

    // Envío de datos al backend (PHP o API)
    fetch('/Enviar.php', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(formData)
})
  .then(res => {
    if (!res.ok) return res.json().then(data => { throw new Error(data.error || 'Error en el envío') });
    return res.json();
  })
  .then(() => {
    alert('Mensaje enviado con éxito');
    handleClose();
    setFormData({ nombre: '', email: '', telefono: '', mensaje: '', whatsapp: false });
    setErrors({});
  })
  .catch(err => alert(err.message));
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Contacto para Venta Mayorista</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} noValidate>
          <Form.Group className="mb-3">

            <p className='pnegro'><strong>¡Hola! ¿Cómo estás?</strong></p>
            <p className='pnegro'>¿Querés vender <em>Guanteo</em> en tu tienda?</p>
            <p className='pnegro'>Dejanos tus datos de contacto y contanos un poco sobre tu local: dónde está ubicado, qué tipo de juegos trabajás y cualquier otra info que quieras compartir.</p>
            <p className='pnegro'>En breve te vamos a escribir con toda la información mayorista.</p>
            <Form.Label>Nombre *</Form.Label>
            <Form.Control
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              isInvalid={!!errors.nombre}
              maxLength={100}
              required
            />
            <Form.Control.Feedback type="invalid">
              {errors.nombre}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email *</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              isInvalid={!!errors.email}
              maxLength={100}
              required
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Teléfono</Form.Label>
            <Form.Control
              type="text"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              isInvalid={!!errors.telefono}
              maxLength={20}
            />
            <Form.Control.Feedback type="invalid">
              {errors.telefono}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Mensaje *</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="mensaje"
              value={formData.mensaje}
              onChange={handleChange}
              isInvalid={!!errors.mensaje}
              maxLength={500}
              required
            />
            <Form.Control.Feedback type="invalid">
              {errors.mensaje}
            </Form.Control.Feedback>
            <br></br>
                  <Form.Check
          type="checkbox"
          name="whatsapp"
          label="Quiero que me escriban por WhatsApp"
          checked={formData.whatsapp}
          onChange={handleChange}
        />
      
          </Form.Group>
          

          <Button variant="success" type="submit" className="w-100">
            📩 Enviar
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
